import { render, staticRenderFns } from "./PartialDiscount.vue?vue&type=template&id=b870f48e&"
import script from "./PartialDiscount.vue?vue&type=script&lang=js&"
export * from "./PartialDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports